import $ from "jquery";
import { curry, pipe } from "ramda";
import { tcDialog } from "mobile/common/tc-dialog.js";
function processItemTypes(currentSeat, itemTypes) {
  return itemTypes
    .filter(function (item) {
      return currentSeat.itemTypes.indexOf(item.id) !== -1;
    })
    .map(function (item) {
      item.selected = item.id == currentSeat.itemType;
      return item;
    });
}

function getActiveItemType(itemTypes) {
  return itemTypes.filter(function (item) {
    return item.selected === true;
  })[0];
}

function buildOrderRequestBody(
  sectionId,
  selectedSeats,
  trackingLink,
  promoCodes,
  orderPromoCode
) {
  var promoCodesObj = promoCodes.reduce(function (acc, cur) {
    acc[cur.item_type_id] = cur.name;
    return acc;
  }, {});
  var response = {
    order: {
      tracking_link_id: trackingLink || "",
      order_lines_attributes: {},
    },
  };

  var orderLineTemplate = function (item_type_id, promo_code_name) {
    return {
      amount: 0,
      item_type_id: item_type_id,
      promo_code_name: promo_code_name || "",
      details: [],
    };
  };

  var seatTemplate = function (seat, row, sectionId) {
    return {
      seat: seat,
      row: row,
      section_id: sectionId,
    };
  };

  var itemTypes = [];

  response.order.order_lines_attributes = selectedSeats.reduce(function (
    acc,
    cur
  ) {
    var curItemType = cur.itemType;
    itemTypes.push(curItemType);
    var index = itemTypes.indexOf(curItemType);
    acc[index] =
      acc[index] || orderLineTemplate(curItemType, promoCodesObj[curItemType]);
    acc[index].amount += 1;
    acc[index].details.push(seatTemplate(cur.coll, cur.row, sectionId));
    return acc;
  },
  {});

  response.order.promo_code = orderPromoCode;

  return response;
}

var setElementStatus = curry(function setElementStatus(selector, status) {
  return $(selector).prop("disabled", !status);
});

var setSubmitButtonStatus = setElementStatus(".js-submit-selected-tickets");

// Dialogs
var legendDialog = tcDialog({
  templateId: "legendDialog",
});

var seatDialogConfig = {
  construct: function ($$, data) {
    $$.on(
      "change",
      function () {
        data.currentItem.itemType = $(".js-itemType").val();
        data.itemTypes = processItemTypes(data.currentItem, data.itemTypes);
        data.itemType = getActiveItemType(data.itemTypes);
        $$.update(data);
      },
      ".js-itemType"
    );
    $$.on(
      "click",
      function () {
        $$.resolve(data.currentItem);
      },
      ".js-save"
    );
    $$.on(
      "click",
      function () {
        $$.reject({
          message: "ITEM_REMOVE",
        });
      },
      ".js-delete"
    );
  },
  templateId: "selectedSeatEditDialog",
};

var selectedSeatCreateDialog = tcDialog(
  $.extend({}, seatDialogConfig, {
    showClose: false,
  })
);

var selectedSeatEditDialog = tcDialog(seatDialogConfig);

window.mobileSeatsManager = seatsManager({
  initialize: function (config) {
    config.selectedItems = [];
    config.$form.on("click", ".js-selected-seat", function (e) {
      var key = $(e.currentTarget).attr("data-key");
      var currentItem = $.extend({}, config.selectedItems[key]);
      var itemTypes = processItemTypes(currentItem, config.data.item_types);
      selectedSeatEditDialog({
        currentItem: currentItem,
        itemTypes: itemTypes,
        itemType: getActiveItemType(itemTypes),
      })
        .then(function (res) {
          config.selectedItems[key] = res;
          return config.selectedItems;
        })
        .then(config.actions.renderSelectedItems)
        .catch(function (err) {
          if (err.message == "ITEM_REMOVE") {
            config.actions.remove(currentItem.row, currentItem.coll);
          } else {
            console.log("error", err);
          }
        });
    });

    $(".js-legend").on("click", legendDialog);

    $(".js-submit-selected-tickets").on("click", function (e) {
      setSubmitButtonStatus(false);
      e.preventDefault();
      var sectionId = config.$form.attr("data-section-id");
      var trackingLink = config.$form.attr("data-tracking-link");
      var orderPromoCode = config.$form.attr("data-promo-code");
      orderPromoCode =
        orderPromoCode && orderPromoCode != "" ? orderPromoCode : null;
      var responseBody = buildOrderRequestBody(
        sectionId,
        config.selectedItems,
        trackingLink,
        config.data.promo_codes,
        orderPromoCode
      );

      $.ajax({
        type: "POST",
        url: config.$form.attr("action"),
        dataType: "script",
        data: responseBody,
      }).done(function () {
        setSubmitButtonStatus(true);
      });
    });
  },
  add: function (config, row, coll, type, itemTypes, uuid) {
    setSubmitButtonStatus(true);
    config.selectedItems.push({
      id: row + ":" + coll,
      row: row,
      coll: coll,
      type: type,
      //Set default item type if exist
      itemType: config.$form.attr("data-item-type-id") || null,
      itemTypes: itemTypes,
      area_uuid: uuid,
    });
    config.actions.renderSelectedItems(config.selectedItems);

    var key = config.selectedItems.length - 1;
    var currentItem = config.selectedItems[key];
    var itemTypes = processItemTypes(currentItem, config.data.item_types);

    selectedSeatCreateDialog({
      currentItem: currentItem,
      itemTypes: itemTypes,
      itemType: getActiveItemType(itemTypes),
    })
      .then(function (res) {
        config.selectedItems[key] = res;
        return config.selectedItems;
      })
      .then(config.actions.renderSelectedItems)
      .catch(function (err) {
        if (err.message == "ITEM_REMOVE" || err.message == "DIALOG_LEAVE") {
          config.actions.remove(currentItem.row, currentItem.coll);
        } else {
          console.log("error", err);
        }
      });
  },
  update: function (config, obj) {
    var findSeat = curry(function (selectedSeat, arenaSeat) {
      return selectedSeat.id === arenaSeat.row + ":" + arenaSeat.seat;
    });
    var uniqReduces = function (acc, cur) {
      if (acc.indexOf(cur) === -1) {
        acc.push(cur);
      }
      return acc;
    };
    config.selectedItems = config.selectedItems.map(function (selectedSeat) {
      selectedSeat.itemTypes = selectedSeat.itemTypes
        .concat(
          obj.seating_arrangements.seats.filter(findSeat(selectedSeat))[0]
            .item_type_ids
        )
        .reduce(uniqReduces, []);
      return selectedSeat;
    });
    config.data.promo_codes = config.data.promo_codes.concat(obj.promo_codes);
  },
  remove: function (config, row, coll) {
    var id = row + ":" + coll;
    config.selectedItems = config.selectedItems.filter(function (item) {
      return item.id !== id;
    });
    if (config.selectedItems.length == 0) {
      setSubmitButtonStatus(false);
    }
    config.actions.renderSelectedItems(config.selectedItems);
    config.$form.trigger("seat:remove", [[row, coll]]);
  },
  renderSelectedItems: function (config, items) {
    config.$form.empty();
    config.$form.append(selectedSeatsComponent(items));
    return items;
  },
  assignSelectedItems: function (config, items) {
    config.selectedItems[key] = items;
    return config.selectedItems;
  },
});

//  Selected seats component
var selectedSeatsComponent = function (items) {
  var source = $("#selectedSeat").html();
  var template = Handlebars.compile(source);
  var renderedSelectedItems = items.map(function (item, index) {
    return pipe(injectItemClassName, injectItemKey(index), template)(item);
  });
  return renderedSelectedItems;
};

var injectItemClassName = function (item) {
  item.className = item.itemType
    ? "tc-mobile-section-tickets--item"
    : "tc-mobile-section-tickets--item__disabled";
  return item;
};

var injectItemKey = curry(function (key, item) {
  item.key = key;
  return item;
});
